/* eslint-disable no-sequences */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */

import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// import {
//   Datepicker, Input, setOptions,
// } from '@mobiscroll/react';
// import moment from 'moment';
import style from './OrarioTile.module.scss';
import TextField from '../../../../components/TextField/TextField';
import IconButton from '../../../../components/Buttons/IconButton/IconButton';
import AddIcon from '../../../../components/Icons/AddIcon';
import RemoveIcon from '../../../../components/Icons/RemoveIcon';
import CopyIcon from '../../../../components/Icons/CopyIcon';
// import useWindowsSize from '../../../../utils/useWindowsSize';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';

function OrarioTile(
  {
    giorni,
    giorno,
    setFieldValue,
    index,
  },

) {
  const [isOrarioDalOpen, setIsOrarioDalOpen] = useState(false);
  const [isOrarioAllOpen, setIsOrarioAllOpen] = useState(false);
  const [isOrarioDal2Open, setIsOrarioDal2Open] = useState(false);
  const [isOrarioAll2Open, setIsOrarioAll2Open] = useState(false);
  const [addiotionalHoursFieldsOpen, setAddiotionalHoursFieldsOpen] = useState(false);
  const [isCopyHoursModalOpen, setIsCopyHoursModalOpen] = useState(false);
  const [weekDaySelected, setWeekDaySelected] = useState('');
  const [clickedDay, setClickedDay] = useState([0]);
  // rimango due variabili per fare un check in caso un orario dovesse essere precedente all'altro
  const [start, setStart] = useState({ ora: '8', minuto: '00' });
  const [end, setEnd] = useState({ ora: '20', minuto: '00' });
  const [start2, setStart2] = useState({ ora: '13', minuto: '00' });
  const [end2, setEnd2] = useState({ ora: '14', minuto: '00' });
  const orari = {
    ore: [
      '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22',
    ],
    minuti: [
      '00', '15', '30', '45',
    ],
  };

  const handleAddiotionalHoursFieldsOpen = async (e) => {
    await setAddiotionalHoursFieldsOpen(e);
    setFieldValue(`giorni.${index}.fullDay`, e);
  };

  return (
    <div className={giorni[index].weekDay === weekDaySelected ? clsx(style.orario__tile__selected) : clsx(style.orario__tile)}>
      <div className={clsx(style.orario__leading__container)}>

        <div className={clsx(style.orario__leading)} key={giorno.weekDay}>
          <TextField
            name="closing"
            type="checkbox"
            checked={!giorno.isClosed}
            onChange={() => {
              setWeekDaySelected('');
              setAddiotionalHoursFieldsOpen(false);
              setFieldValue(`giorni.${index}.isClosed`, !giorno.isClosed);
            }}
          />
          <h3 className={clsx(style.orario__leading__name)}>{giorno.giorno}</h3>
        </div>
        <div className={clsx(style.orario__body)}>
          {
            giorno.isClosed ? <p className={clsx(style.orari__closed)}>Chiuso</p> : giorno.orari.map((orario, orarioIndex) => (
              <div className={clsx(style.orari__main__container)} key={orarioIndex}>
                <div className={clsx(style.orari__input__container)}>
                  {isOrarioDalOpen && (
                    <div className={clsx(style.orari__input__modal)}>
                      <div className={clsx(style.orari__input__modal__selector)}>
                        {orari.ore.map((item) => (
                          <div
                            className={item === start.ora ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                            onClick={() => setStart({ ...start, ora: item })}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div>:</div>
                      <div className={clsx(style.orari__input__modal__selector)}>
                        {orari.minuti.map((item) => (
                          <div
                            className={item === start.minuto ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                            onClick={() => setStart({ ...start, minuto: item })}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div
                        className={clsx(style.orari__input__cancel__button)}
                        onClick={() => {
                          setIsOrarioDalOpen(false);
                          setStart({ ora: start.ora, minuto: start.minuto });
                        }}
                      >
                        Annulla
                      </div>
                      <div
                        className={start.minuto !== '' && start.ora !== '' ? clsx(style.orari__input__confirm__button) : clsx(style.orari__input__confirm__button__disabled)}
                        onClick={() => {
                          setFieldValue(`giorni.${index}.orari[0].dal`, `${start.ora}:${start.minuto}`);
                          setIsOrarioDalOpen(false);
                        }}
                      >
                        Salva
                      </div>
                    </div>
                  )}
                  <div className={clsx(style.orario__input__container)}>
                    <div className={clsx(style.orario__input__label)}>Apertura</div>
                    <div
                      className={clsx(style.orari__input)}
                      onClick={() => setIsOrarioDalOpen(true)}
                    >
                      { orario.dal || 'Dalle'}
                    </div>
                  </div>
                  {isOrarioAllOpen && (
                    <div className={clsx(style.orari__input__modal)}>
                      <div className={clsx(style.orari__input__modal__selector)}>
                        {orari.ore.map((item) => (
                          <div
                            className={item === end.ora ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                            onClick={() => setEnd({ ...end, ora: item })}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div>:</div>
                      <div className={clsx(style.orari__input__modal__selector)}>
                        {orari.minuti.map((item) => (
                          <div
                            className={item === end.minuto ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                            onClick={() => setEnd({ ...end, minuto: item })}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div
                        className={clsx(style.orari__input__cancel__button)}
                        // da fare che elimini anche end
                        onClick={() => {
                          setIsOrarioAllOpen(false);
                          setEnd({ ora: end.ora, minuto: end.minuto });
                        }}
                      >
                        Annulla
                      </div>
                      <div
                        className={start.minuto !== '' && start.ora !== '' ? clsx(style.orari__input__confirm__button) : clsx(style.orari__input__confirm__button__disabled)}
                        onClick={() => {
                          setIsOrarioAllOpen(false);
                          setFieldValue(`giorni.${index}.orari[0].all`, `${end.ora}:${end.minuto}`);
                        }}
                      >
                        Salva
                      </div>
                    </div>
                  )}
                  <div className={clsx(style.orario__input__container)}>
                    <div className={clsx(style.orario__input__label)}>Chiusura</div>
                    <div
                      className={clsx(style.orari__input)}
                      onClick={() => setIsOrarioAllOpen(true)}
                    >
                      { orario.all || 'Alle'}
                    </div>
                  </div>
                </div>

              </div>

            ))
          }

        </div>
        <div className={clsx(style.orario__trailing)}>
          {
          giorno.isClosed === true
            ? ''
            : addiotionalHoursFieldsOpen === false
              ? (
                <IconButton
                  type="button"
                  onClick={() => {
                    setWeekDaySelected(giorno.weekDay);
                    handleAddiotionalHoursFieldsOpen(true);
                  }}
                  icon={<AddIcon />}
                />
              )
              : (
                <IconButton
                  type="button"
                  onClick={() => {
                    setWeekDaySelected('');
                    handleAddiotionalHoursFieldsOpen(false);
                  }}
                  icon={<RemoveIcon />}
                />
              )
            }
          <div>
            <IconButton type="button" onClick={() => setIsCopyHoursModalOpen(!isCopyHoursModalOpen)} icon={<CopyIcon />} />
          </div>
        </div>
      </div>

      {addiotionalHoursFieldsOpen && (
        <div className={clsx(style.orari__input__container2)}>
          <div className={clsx(style.orari__pausa__input__container)}>

            <div className={clsx(style.orari__input__pause)}>
              Pausa:
            </div>

            {isOrarioDal2Open && (
            <div className={clsx(style.orari__input__modal)}>
              <div className={clsx(style.orari__input__modal__selector)}>
                {orari.ore.map((item) => (
                  <div
                    className={item === start2.ora ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                    onClick={() => setStart2({ ...start2, ora: item })}
                  >
                    {item}
                  </div>
                ))}

              </div>
              <div>:</div>
              <div className={clsx(style.orari__input__modal__selector)}>
                {orari.minuti.map((item) => (
                  <div
                    className={item === start2.minuto ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                    onClick={() => setStart2({ ...start2, minuto: item })}
                  >
                    {item}
                  </div>
                ))}

              </div>
              <div
                className={clsx(style.orari__input__cancel__button)}
                onClick={() => {
                  setStart2({ ora: start2.ora, minuto: start2.minuto });
                  setIsOrarioDal2Open(false);
                }}
              >
                Annulla
              </div>
              <div
                className={clsx(style.orari__input__confirm__button)}
                onClick={() => {
                  setFieldValue(`giorni.${index}.orari[0].dal2`, `${start2?.ora}:${start2?.minuto}`);
                  setIsOrarioDal2Open(false);
                }}
              >
                Salva
              </div>
            </div>
            )}
            <div className={clsx(style.orario__input__container)}>
              <div className={clsx(style.orario__input__label)}>Inizio</div>
              <div
                className={clsx(style.orari__pausa__input)}
                onClick={() => setIsOrarioDal2Open(true)}
              >
                {giorni[index].orari[0].dal2 !== '' ? giorni[index].orari[0].dal2 : `${start2.ora}:${start2.minuto}`}

              </div>
            </div>
            {isOrarioAll2Open && (
            <div className={clsx(style.orari__input__modal)}>
              <div className={clsx(style.orari__input__modal__selector)}>
                {orari.ore.map((item) => (
                  <div
                    className={item === end2.ora ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                    onClick={() => setEnd2({ ...end2, ora: item })}
                  >
                    {item}
                  </div>
                ))}

              </div>
              <div>:</div>
              <div className={clsx(style.orari__input__modal__selector)}>
                {orari.minuti.map((item) => (
                  <div
                    className={item === end2.minuto ? clsx(style.orari__input__modal__item__selected) : clsx(style.orari__input__modal__item)}
                    onClick={() => setEnd2({ ...end2, minuto: item })}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div
                className={clsx(style.orari__input__cancel__button)}
                onClick={() => {
                  setEnd2({ ora: end2.ora, minuto: end2.minuto });
                  setIsOrarioAll2Open(false);
                }}
              >
                Annulla
              </div>
              <div
                className={clsx(style.orari__input__confirm__button)}
                onClick={() => {
                  setIsOrarioAll2Open(false);
                  setFieldValue(`giorni.${index}.orari[0].all2`, `${end2.ora}:${end2.minuto}`);
                }}
              >

                Salva
              </div>
            </div>
            )}
            <div className={clsx(style.orario__input__container)}>
              <div className={clsx(style.orario__input__label)}>Fine</div>
              <div
                className={clsx(style.orari__pausa__input)}
                onClick={() => setIsOrarioAll2Open(true)}
              >
                {giorni[index].orari[0].all2 !== '' ? giorni[index].orari[0].all2 : `${end2.ora}:${end2.minuto}`}
              </div>
            </div>
          </div>
        </div>
      )}
      {isCopyHoursModalOpen && (
        <div className={clsx(style.orari__copy__modal)}>
          <h3 className={clsx(style.orari__copy__modal__title)}>Copia questi orari anche per i giorni:</h3>
          <div className={clsx(style.orari__copy__modal__buttons)}>
            {giorni.map((giornoButton, key) => (
              <>
                {giornoButton.weekDay === giorno.weekDay ? '' : (
                  <div
                      // checked={giorno.isClosed === giornoCopy.isClosed ? true : giornoCopy.orari[0] === giorno.orari[0]}
                    onClick={() => (
                      clickedDay.includes(giornoButton.weekDay) ? setClickedDay(clickedDay.filter((item) => item !== giornoButton.weekDay))
                        : setClickedDay([...clickedDay, giornoButton.weekDay]),
                      giorno.isClosed ? setFieldValue(`giorni.${key}.isClosed`, true)
                        : (giorno.orari[0].dal2 === '' ? (
                          setFieldValue(`giorni.${key}.orari[0]`, giorno.orari[0]),
                          setFieldValue(`giorni.${key}.isClosed`, false)
                        )
                          : (
                            () => handleAddiotionalHoursFieldsOpen(true),
                            setFieldValue(`giorni.${key}.orari[0]`, giorno.orari[0]),
                            setFieldValue(`giorni.${key}.isClosed`, false)
                          ))
                    )}
                    className={clickedDay.includes(giornoButton.weekDay) ? clsx(style.orario__copy__modal__button__selected) : clsx(style.orario__copy__modal__button)}
                  >
                    <h3 className={clsx(style.orario__copy__modal__name)}>{giornoButton.giorno}</h3>
                  </div>
                )}
              </>
            ))}

          </div>
        </div>
      )}
    </div>
  );
}

OrarioTile.propTypes = {
  giorni: PropTypes.arrayOf(PropTypes.shape({
    weekDay: PropTypes.number.isRequired,
    giorno: PropTypes.string.isRequired,
    isClosed: PropTypes.bool.isRequired,
    orari: PropTypes.arrayOf(PropTypes.shape({
      dal: PropTypes.string,
      all: PropTypes.string,
      dal2: PropTypes.string,
      all2: PropTypes.string,
    })).isRequired,
  })).isRequired,
  giorno: PropTypes.shape({
    weekDay: PropTypes.number.isRequired,
    giorno: PropTypes.string.isRequired,
    isClosed: PropTypes.bool.isRequired,
    orari: PropTypes.arrayOf(PropTypes.shape({
      dal: PropTypes.string,
      all: PropTypes.string,
      dal2: PropTypes.string,
      all2: PropTypes.string,
    })).isRequired,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default OrarioTile;
